var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcon = function SvgIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 25.974,
    height: 45.114,
    viewBox: "0 0 25.974 45.114",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flame-main",
    fill: "#f36e21",
    d: "M13.44 44.536s-4.663-.819-6.188-1.874c-2.676-1.853-2.946-4.123-2.946-4.123-1.683-8.25-.9-7.918.544-20.81-.733 1.197 5.988 3.001 7.317 10.822 2.015 12.406 4.984 13.414 1.803 15.985"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-one",
    fill: "#f6891f",
    d: "M7.097 25.342c-.153-2.722 1.788-3.436 2.815-7.86.55-2.368.83-6.017-.013-11.187 0 0 6.03 4.57 7.573 8.577 1.187 3.083 2.986 7.736 5.637 14.546 4.302 15.368-9.746 14.665-9.685 14.824s-5.744-.08-4.392-5.487c1.352-5.408-1.324-8.416-1.935-13.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-two",
    fill: "#ffd04a",
    d: "M20.352 15.67s-1.199 6.404-3.658 9.449c-2.347 4.493-7.642 11.167-1.512 18.007 0 0 15.703-5.009 5.17-27.456z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-three",
    fill: "#fdba16",
    d: "M13.824 14.816c1.468 3.081-1.978 20.705-.61 30.511 0 0 11.615-6.94 7.874-15.74-1.684-9.107-5.963-13.25-7.264-14.771"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-six",
    fill: "#ffd04a",
    d: "M10.502 19.312c-3.547 2.312-7.635 22.528 1.049 24.9 7.563 3.063-1.864-15.769-1.049-24.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-four",
    fill: "#f36e21",
    d: "M21.855 22.275s.106 8.533-2.847 13.304c-2.951 4.772-2.836 8.885-2.836 8.885s6.889-1.154 7.73-8.748c.35-3.172.679-8.322-2.047-13.442z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "flame-main-five",
    fill: "#fdba16",
    d: "M5.201 21.079S.431 40.207 8.182 43.188s-.913-14.236-2.981-22.109"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "flame",
    fill: "#f36e21",
    d: "M18.918 16.404s2.657 3.115 1.349 4.898c-1.835.08.35-3.571-1.349-4.898"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "flame-one",
    fill: "#f36e21",
    d: "M5.137 26.63s-1.13 3.935.8 5.017c1.7-.686-.707-3.415-.8-5.017"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path300",
    fill: "#f36e21",
    d: "M4.145 15.224s-1.172 1.809-.367 2.65c.963-.085-.43-1.84.367-2.65"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export default ForwardRef;